

import { useState } from "react"
import { BiPlusCircle } from "react-icons/bi"

export default function FieldsForm({ fields, setFields, errors, setErrors, loading, validateForm, FIELD_TYPES }) {
    const generateCode = () => Date.now().toString()
    const [newField, setNewField] = useState({
        nom_ligne: "",
        libelle_ligne: "",
        type_ligne: "TEXT",
        afficher: "Oui",
        requis: "Non",
        mobile: "Non",
        options_ligne: "",
        formulaire: 0,
        rang: 0,
    })

    const handleAddField = async () => {
        const fieldErrors = validateForm(newField)
        if (Object.keys(fieldErrors).length > 0) {
            setErrors(fieldErrors)
            return
        }

        try {
            const fieldToAdd = {
                ...newField,
                key_ligne: generateCode(),
                rang: fields.length + 1,
                options_ligne: newField.type_ligne === "SELECT" ? newField.options_ligne : "",
            }
            setFields([...fields, fieldToAdd])
            setNewField({
                nom_ligne: "",
                libelle_ligne: "",
                type_ligne: "TEXT",
                afficher: "Oui",
                requis: "Non",
                mobile: "Non",
                options_ligne: "",
                formulaire: 0,
                rang: 0,
            })
            setErrors({})
        } catch (err) {
            // Error handled by AppContext
        }
    }

    return (
        <div className="">
            <div className="mb-2">
                <label className="form-label">Nom technique *</label>
                <input type="text" className={`form-control form-control-sm ${errors.nom_ligne ? "is-invalid" : ""}`} value={newField.nom_ligne}
                    onChange={(e) => setNewField({ ...newField, nom_ligne: e.target.value })}
                    placeholder="ex: nom_champ" />
                {errors.nom_ligne && <div className="invalid-feedback">{errors.nom_ligne}</div>}
            </div>

            <div className="mb-2">
                <label className="form-label">Libellé *</label>
                <input type="text" className={`form-control form-control-sm ${errors.libelle_ligne ? "is-invalid" : ""}`} value={newField.libelle_ligne}
                    onChange={(e) => setNewField({ ...newField, libelle_ligne: e.target.value })}
                    placeholder="ex: Libellé du champ" />
                {errors.libelle_ligne && <div className="invalid-feedback">{errors.libelle_ligne}</div>}
            </div>

            <div className="row mb-2">
                <div className="col-md-6">
                    <label className="form-label">Type</label>
                    <select className="form-select form-select-sm" value={newField.type_ligne}
                        onChange={(e) => setNewField({ ...newField, type_ligne: e.target.value })}>
                        {FIELD_TYPES.map((type) => (
                            <option key={type.value} value={type.value}>
                                {type.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-6">
                    <label className="form-label" htmlFor="requis"> Champ obligatoire</label>
                    <select name="requis" id="requis" className="form-select form-select-sm"
                        value={newField.requis}
                        onChange={(e) => setNewField({ ...newField, requis: e.target.value })}>
                        <option value="Oui">Obligatoire</option>
                        <option value="Non">Facultatif</option>
                    </select>
                </div>
            </div>

            {newField.type_ligne === "SELECT" && (
                <div className="mb-2">
                    <label className="form-label">Options (séparées par des virgules)</label>
                    <input type="text" className="form-control form-control-sm" value={newField.options_ligne}
                        onChange={(e) => setNewField({ ...newField, options_ligne: e.target.value })}
                        placeholder="Option 1, Option 2, Option 3" />
                </div>
            )}

            <div className="row mb-2">
                <div className="col-md-6">
                    <label className="form-label" htmlFor="afficher">Visible dans le formulaire</label>
                    <select name="afficher" id="afficher" className="form-select form-select-sm"
                        value={newField.afficher}
                        onChange={(e) => setNewField({ ...newField, afficher: e.target.value })}>
                        <option value="Oui">Visible</option>
                        <option value="Non">Invisible</option>
                    </select>
                </div>
                <div className="col-md-6">
                    <label className="form-label" htmlFor="mobile">Visible sur mobile</label>
                    <select name="mobile" id="mobile" className="form-select form-select-sm"
                        value={newField.mobile}
                        onChange={(e) => setNewField({ ...newField, mobile: e.target.value })}>
                        <option value="Oui">Visible</option>
                        <option value="Non">Invisible</option>
                    </select>
                </div>
            </div>

            <button className="btn btn-primary btn-sm mt-4 px-2 d-flex align-items-center justify-content-center w-100"
                onClick={handleAddField}
                disabled={loading || !newField.nom_ligne || !newField.libelle_ligne}>
                <BiPlusCircle className="me-1" />
                Ajouter le champ
            </button>
        </div>
    )
}